module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t2"
  }, [_vm._v("Beware of Psychics Box Set")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_vm._v("By Holly Day")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('a', {
    attrs: {
      "id": "a4"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('a', {
    attrs: {
      "href": "#/004#a58"
    }
  }, [_vm._v("How to Hook a Vampire")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('a', {
    attrs: {
      "href": "#/004#a59"
    }
  }, [_vm._v("Chapter 1")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('a', {
    attrs: {
      "href": "#/005#a65"
    }
  }, [_vm._v("Chapter 2")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('a', {
    attrs: {
      "href": "#/006#a67"
    }
  }, [_vm._v("Chapter 3")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/007#a73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/008#a75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/009#a78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/010#a79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/011#a81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/012#a83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/013#a84",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/014#a86",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/015#a89",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/016#a90",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/017#a93",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    attrs: {
      "href": "#/018#a94",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Bear Claw")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/018#a95",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 1")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/019#a99",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/020#a101",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/021#a103",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/022#a104",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/023#a106",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/024#a108",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/025#a110",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/026#a112",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/027#a113",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/028#a115",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/029#a116",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/030#a118",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/031#a120",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/032#a121",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/033#a123",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/034#a125",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/035#a127",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/036#a129",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/037#a131",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 20")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/038#a133",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 21")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/039#a134",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 22")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/040#a135",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 23")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/041#a136",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 24")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/042#a137",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    attrs: {
      "href": "#/043#a138",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Batshit Bassel")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/043#a139",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 1")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/044#a140",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/045#a141",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/046#a142",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/047#a143",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/048#a144",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/049#a145",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/050#a146",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")]), _c('a', {
    attrs: {
      "href": "#/#a57"
    }
  })]), _vm._v(" "), _c('h1', {
    staticClass: "h10"
  }, [_c('a', {
    attrs: {
      "id": "ncx77"
    }
  }), _c('a', {
    attrs: {
      "id": "a57"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d45bd66","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/003.vue
// module id = 60
// module chunks = 0